export const FormatNumber = (num: number) => {
    return num.toString().replace(/(\d)(?=(\d{0})+(?!\d))/g, '$1 ');
}